import { UniversalRoll } from "@/pages/catalogs/models/UniversalRoll";
import { MenuOptionType } from "@dexteel/mesf-core";
import { DeleteSweep } from "@mui/icons-material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";

type Props = {
	setSelectedRowData: (universal: UniversalRoll) => void;
	setShowModal: (
		modal:
			| "create"
			| "update"
			| "delete"
			| "deleteMultiple"
			| "confirmRollsetDeactivation"
			| "activeCarrier"
			| "",
	) => void;
};
export const useUniversalRollOptionsFunctions = ({
	setSelectedRowData,
	setShowModal,
}: Props) => {
	const getMenuOptions = (data: UniversalRoll | any) => {
		let options: MenuOptionType[] = [];
		options = options.concat([
			{
				name: "New Roll",
				key: "new_roll",
				onClick: () => {
					setShowModal("create");
				},
				icon: <PlaylistAddIcon />,
			},
		]);
		if (data) {
			const needsRollsetConfirmation =
				data.IsInActiveRollset && !data.IsInActiveCarrier;

			options = options.concat([
				{
					name: "Edit Roll",
					key: "edit_roll",
					onClick: () => {
						setSelectedRowData(data);
						setShowModal("update");
					},
					icon: <EditIcon />,
				},
				{
					name: "Delete Roll",
					key: "delete_roll",
					onClick: () => {
						setSelectedRowData(data);
						if (data.IsInActiveCarrier) {
							setShowModal("activeCarrier");
						} else if (needsRollsetConfirmation) {
							setShowModal("confirmRollsetDeactivation");
						} else {
							setShowModal("delete");
						}
					},
					icon: <DeleteIcon />,
				},
				...(data.selectedRows?.length > 1
					? [
							{
								name: `Delete selected (${data.selectedRows.length})`,
								key: "delete_selected_universal_rolls",
								onClick: () => {
									setShowModal("deleteMultiple");
								},
								icon: <DeleteSweep />,
							},
						]
					: []),
			]);
		}
		return options;
	};
	return {
		getMenuOptions,
	};
};
